import ChallengeUser from './ChallengeUser';

export default ChallengeUser;
